export enum TenantEnum {
  null = '',
  pick6 = 'nfl-pick6',
  super6 = 'nfl-super6',
  tsnLeafsPick6 = 'tsn-leafs-pick6',
  tsnRaptorsPick6 = 'tsn-raptors-pick6',
}
